import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function formatNumber(val) {
  if (Number.isInteger(val)) return String(val);
  return String(val.toFixed(2)).replace(/\.?0+$/, "").replace(".", ",");
}

export function generateTask() {
  const startFuel = Math.floor(Math.random() * 31) + 35; // 35..65 l
  const burnPer100 = Math.floor(Math.random() * 9) + 4; // 4..12 l / 100 km

  const distances = [50, 75, 100, 125, 150, 175, 200, 225, 250, 300];
  const valid = distances.filter((d) => startFuel - (burnPer100 * d) / 100 >= 5);
  const km = valid[Math.floor(Math.random() * valid.length)];

  const burn = (burnPer100 * km) / 100;
  const remaining = startFuel - burn;

  return {
    type: "LinearTextFuelRemainingTask",
    data: {
      startFuel,
      burnPer100,
      km,
      burn,
      remaining,
    },
    answer: remaining,
  };
}

export function renderTask({ data }) {
  const { startFuel, burnPer100, km } = data;
  return (
    <>
      <p>
        W baku jest poczatkowo <InlineMath math={`${startFuel}`} /> l paliwa.
      </p>
      <p>
        Samochod spala <InlineMath math={`${burnPer100}`} /> l na{" "}
        <InlineMath math={"100"} /> km.
      </p>
      <p>
        Ile paliwa zostanie po przejechaniu <InlineMath math={`${km}`} /> km?
      </p>
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span>
        <InlineMath math={"\\text{pozostalo}="} />
      </span>
      <FractionInput
        value={userAnswer || ""}
        onChange={onChange}
        disabled={disabled}
        label={"\\text{pozostalo}"}
        suffixLatex={String.raw`\text{l}`}
        compactPreview={true}
      />
    </div>
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.parsed
      : Number(userAnswer);
  if (parsed == null || Number.isNaN(parsed)) return false;
  return Math.abs(parsed - task.answer) < 0.01;
}

export function renderAnswer({ answer }) {
  return (
    <InlineMath math={`\\text{pozostalo}=${formatNumber(answer)}\\ \\text{l}`} />
  );
}

export function renderExplanation({ data }) {
  const { startFuel, burnPer100, km, burn, remaining } = data;

  return (
    <div className="space-y-3">
      <p>
        <b>Krok 1:</b> Tworzymy model liniowy:
      </p>
      <BlockMath math={"f(x)=b-ax"} />
      <BlockMath math={`f(x)=${startFuel}-\\frac{${burnPer100}}{100}x`} />

      <p>
        <b>Krok 2:</b> Obliczamy zuzycie na dystansie{" "}
        <InlineMath math={`${km}`} /> km:
      </p>
      <BlockMath math={`\\frac{${burnPer100}}{100}\\cdot ${km}=${formatNumber(burn)}`} />

      <p>
        <b>Krok 3:</b> Odejmujemy od stanu poczatkowego:
      </p>
      <BlockMath math={`${startFuel}-${formatNumber(burn)}=${formatNumber(remaining)}`} />
      <BlockMath math={`\\text{Odpowiedz: }${formatNumber(remaining)}\\ \\text{l}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer) return <i>(brak odpowiedzi)</i>;

  const raw =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.raw
      : userAnswer;

  if (!raw && raw !== 0) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`\\text{pozostalo}=${String(raw)}\\ \\text{l}`} />;
}
